import { colorsGradient } from '../assets/colors';

export const isHexColor = (color: string): boolean => {
  // the supported hexadecimal digits are 3, 4, 6, 8 by this regex
  const re = /^#(([0-9A-Fa-f]{2}){3,4}|[0-9A-Fa-f]{3,4})$/;
  return re.test(color);
};

export const isRGBColor = (color: string): boolean => {
  const re =
    /rgba?\(\s*(25[0-5]|2[0-4]\d|1\d{1,2}|\d\d?)\s*,\s*(25[0-5]|2[0-4]\d|1\d{1,2}|\d\d?)\s*,\s*(25[0-5]|2[0-4]\d|1\d{1,2}|\d\d?)\s*,?\s*([01\.]\.?\d?)?\s*\)/;
  return re.test(color);
};

export const isValidColor = (color: string): boolean => {
  // this is not very accurate
  // simply inserting '-gradient' will make it valid color
  return isHexColor(color) || isRGBColor(color) || color?.includes('-gradient');
};

// computeColor computes the actual string of color code
// color is either the actual color code or color name.
export const computeColor = (
  color?: string,
  defaultColors?: { [colorName: string]: string },
  defaultColor?: string,
) => {
  if (!color) return defaultColor;
  return defaultColors?.[color] || (isValidColor(color) ? color : undefined);
};

export const isColorGradient = (color: string): boolean =>
  Object.keys(colorsGradient).includes(color) || color?.includes('-gradient');
